export default __webpack_public_path__ + "static/media/pub1-controlled.971c8e94.png";